import { Injectable } from "@angular/core"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"

import { AuthModalComponent } from "../shared-components/modals/auth-modal/auth-modal.component"
import { StudentLoginModalComponent } from "../shared-components/modals/student-login-modal/student-login-modal.component"
import { UserService } from "./user.service"

@Injectable({
    providedIn: "root",
})
export class LMModalService {
    constructor(
        private userService: UserService,
        private modalService: NgbModal
    ) {}

    public openLoginModal() {
        if (this.userService.hasStudentExperience()) {
            this.modalService.open(StudentLoginModalComponent)
        } else {
            this.modalService.open(AuthModalComponent)
        }
    }
}
